import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, ZoomControl } from 'react-leaflet';

import { withStyles, makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
    Paper,
    Grid,
    Button,
    IconButton
} from '@material-ui/core';
import Wrapper from '../../components/Wrapper/Wrapper';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from "@material-ui/lab";
import { MapIcon } from '../../../components/icons';

// import 'react-leaflet-fullscreen/dist/styles.css';
// import 'react-leaflet-fullscreen-control'
// import FullscreenControl from 'react-leaflet-fullscreen';
// import 'react-leaflet-fullscreen/dist/styles.css'


// import L, { Icon } from 'leaflet';

import * as L from "leaflet";
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';
import './Fullscreen.css';
import 'leaflet-easybutton';

// import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';

// import * as leaflet from 'leaflet';
// import 'screenfull';
// import 'leaflet.fullscreen';


import { renderToStaticMarkup } from "react-dom/server";
import { divIcon } from "leaflet";

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { SimShareIcon } from '../../../components/icons';

import {
    getTripDetailsV3,
    getJourneyDetails
} from "../../../store/actions/tripActionCreator";
import { getLocationForSimTracking } from '../../../store/actions/vehicleActionCreator';
import { useHistory, useLocation } from "react-router-dom";
import * as logger from '../../../logger';
import Timer from 'react-compound-timer';
import { getDatePickerDateInStringDDMMMYYYY, getMilliDatePickerDateInStringDDMMMYYYY, getTimeInHHMM } from '../../../utils/utils';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({

    pageContentDiv: {
        height: 'calc(100vh - 115px)',
        overflow: 'auto',
        paddingLeft: 24
    },
    googleButton: {
        borderRadius: 8, color: '#0033cc', backgroundColor: 'white', textTransform: 'capitalize', paddingLeft: 12, paddingRight: 12, fontSize: 12, fontWeight: 300, paddingLeft: 12, paddingRight: 12,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    header: {
        color: 'grey', fontWeight: 'bold', letterSpacing: '0.03em', fontSize: 12, marginLeft: 18,
    },
    cancelButton: {
        fontWeight: 'bold', backgroundColor: '#efeff2', paddingLeft: 35, paddingRight: 35, paddingTop: 7, paddingBottom: 7, borderRadius: 4, textTransform: 'capitalize', letterSpacing: '1px', marginRight: 16,
        '&:hover': {
            backgroundColor: '#efeff2'
        }
    },
    refreshButton: {
        fontWeight: 'bold', backgroundColor: '#0033cc', color: 'white', paddingLeft: 35, paddingRight: 35, paddingTop: 7, paddingBottom: 7, borderRadius: 4, textTransform: 'capitalize', letterSpacing: '1px',
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    refreshButtonDisabled: {
        fontWeight: 'bold', backgroundColor: '#C8C8C8', color: 'white !important', paddingLeft: 35, paddingRight: 35, paddingTop: 7, paddingBottom: 7, borderRadius: 4, textTransform: 'capitalize', letterSpacing: '1px',
        '&:hover': {
            backgroundColor: '#efeff2'
        }
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(1.7)",
        color: "#0033cc"
    },
    timeLineOppositeContent: {
        '&:before': {
            display: 'none',
        }
    },
    timeLineRoot: {
        padding: '0px !important',
        marginBottom: 0
    },
    dotRoot: {
        marginBottom: 0,
        paddingBottom: 0,
        paddingTop: 0,
        paddingLeft: 4,
        paddingRight: 4,
        marginTop: 0,
        backgroundColor: '#0033cc',
        minWidth: 18,
        minHeight: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    dotRootTwoDigit: {
        marginBottom: 0,
        paddingBottom: 2,
        paddingTop: 4,
        paddingLeft: 2,
        paddingRight: 2,
        marginTop: 0,
        backgroundColor: '#0033cc',
        minWidth: 18,
        minHeight: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    dotRootV1: {
        marginBottom: 0,
        paddingBottom: 2,
        paddingTop: 2,
        paddingLeft: 2,
        paddingRight: 2,
        marginTop: 0,
        backgroundColor: '#0033cc'
    },
    dotRootV2: {
        marginBottom: 0,
        paddingBottom: 2,
        paddingTop: 2,
        paddingLeft: 2,
        paddingRight: 2,
        marginTop: 0,
        backgroundColor: '#64a15e'
    },
    timeDot: {
        fontSize: 10,
        fontWeight: 'bold',
        marginTop: '-1px'
    },
    lineConnectorRoot: {
        flexGrow: 'unset',
        height: '100%',
        backgroundColor: '#0033cc'
    },
    lineConnectorRootV1: {
        flexGrow: 'unset',
        height: '100%',
        backgroundColor: '#64a15e'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        color: 'grey',
        marginTop: 4,
        marginBottom: 14
    },
    lineContentRoot: {
        paddingTop: 4
    },
    circleIcon: {
        fontSize: 10,
        marginRight: '0.1em'
    },
    circleIconV1: {
        fontSize: 12,
        marginLeft: '0.03em'
    },
    circleIconV2: {
        fontSize: 10,
        color: 'white',
        width: 11,
        height: '1.05em'
    },
    timeLineContent: {
        paddingTop: 0
    },
    timeLineContentV1: {
        paddingTop: 0,
        marginTop: -2
    },
    lineSeparator: {
        marginTop: 4,
        marginLeft: -1
    },
    divIconV1: {
        backgroundColor: '#0033cc', color: 'white', fontWeight: 'bold', borderRadius: '50%',
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 8,
        paddingRight: 8,
        minWidth: 18,
        minHeight: 18,
        // marginTop: -3,
        paddingBottom: '0.01em'
    },
    divIconV2: {
        backgroundColor: '#0033cc', color: 'white', fontWeight: 'bold', borderRadius: '50%',
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: '0.2em',
        paddingBottom: 3,
        marginTop: -3
    },
    locationIcon: {
        color: 'red',
        marginTop: -26,
        marginLeft: -8
    },
    divV1: {
        marginTop: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between'
    },
    zoomControlV1: {
        borderRadius: 8,
        "& .leaflet-touch": {
            border: 'none'
        }
    },
    fw300: {
        fontWeight: 300
    },
    divV2: {
        display: 'flex', flexDirection: 'column', height: 'inherit'
    },
    divV3: {
        flexBasis: '86%', display: 'flex', justifyContent: 'space-between'
    },
    divV4: {
        flexBasis: '30%'
    },
    divV5: {
        backgroundColor: '#f4f4f5', borderRadius: 8, padding: 16, marginTop: 32, fontWeight: 300
    },
    divV6: {
        display: 'flex', justifyContent: 'space-between', fontSize: 12, color: 'grey', letterSpacing: '0.03em', alignItems: 'center'
    },
    mtV1: {
        marginTop: 6
    },
    mapIcon: {
        color: '#0033cc'
    },
    mtV2: {
        marginTop: 22
    },
    divTimeline: {
        backgroundColor: '#f4f4f5', borderRadius: 8, padding: 16, marginTop: 8, maxHeight: 'calc(100vh - 454px)', minHeight: 'auto', overflow: 'auto'
    },
    divV7: {
        flexBasis: '65%'
    },
    divText: {
        flexBasis: '14%', paddingRight: '4.5em', marginTop: 8
    },
    divV8: {
        display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
    },
    divV9: {
        color: 'black', fontWeight: 300, marginRight: 26,
    },
    divV10: {
        display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 8
    },
    divTracking: {
        backgroundColor: '#D3DDFD',
        color: '#0033cc',
        paddingTop: 4,
        paddingBottom: 4,
        paddingRight: 8,
        paddingLeft: 8,
        borderRadius: 4,
        letterSpacing: '0.04em',
    }
}));

const MapComponent = ({ user, vehicle, dispatchTripDetailsAction, dispatchGetSimTrackingLocation }) => {

    const [polyLine, setPolyLine] = useState([]);
    const [locationData, setLocationData] = useState([]);
    const [refreshClicked, setRefreshClicked] = useState(false);
    const [vehicleData, setVehicleData] = useState({});

    let history = useHistory();
    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let simTrackingConfig = JSON.parse(localStorage.getItem('USER_APP_CONFIG')) && JSON.parse(localStorage.getItem('USER_APP_CONFIG')).sim_tracking_config ? JSON.parse(localStorage.getItem('USER_APP_CONFIG')).sim_tracking_config : {};
    let journeyId = "";
    if (path[path.length - 1]) {
        journeyId = path[path.length - 1];
    }
    let journey = user && user.singleTripData && user.singleTripData.id ? user.singleTripData : null
    let tripId  = journey&&journey.trips&&journey.trips.length>0 && journey.trips[0] && journey.trips[0].id?journey.trips[0].id:''

    const classes = useStyles();
    const position = [51.505, -0.09];

    const polyline = [
        [51.505, -0.09],
        [51.51, -0.1],
        [51.51, -0.12],
    ];

    const polylineTest = [
        [25.9126424, 93.7245191],
        [25.900347, 93.715583],
        [25.89657, 93.709209],
        [25.893361, 93.7111]
    ]

    const polyOption = { color: '#0033cc' };

    const center = [51.505, -0.09];

    // useEffect(() => {
    //     L.easyButton('<span class="star">&starf;</span>', function () {
    //         alert('you just clicked the html entity \&starf;');
    //     });
    // }, [])

    // Number Icon marker.
    const iconMarkup = index => renderToStaticMarkup(
        <div className={classes.divIconV1}>
            {index}
        </div>
    );
    const customMarkerIcon = index => divIcon({
        html: iconMarkup(index)
    });

    // Start Icon.
    const iconMarkupStart = renderToStaticMarkup(
        <div className={classes.divIconV2}>
            <FiberManualRecordIcon className={classes.circleIconV2} />
        </div>
    );
    const customMarkerIconStart = divIcon({
        html: iconMarkupStart
    })


    //Current Icon.
    const iconMarkupCurrent = renderToStaticMarkup(
        <div>
            <LocationOnIcon className={classes.locationIcon} />
        </div>
    );
    const customMarkerIconCurrent = divIcon({
        html: iconMarkupCurrent
    })

    useEffect(() => {

        if (!user.singleTripData) {
            dispatchTripDetailsAction(journeyId, () => {
            },
                () => {

                }
            );
        }

    }, [user.singleTripData]);

    useEffect(() => {

        if (user.singleTripData && user.singleTripData.vehicle) {
            setVehicleData(user.singleTripData.vehicle);
        }

        if (user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.tracking && user.singleTripData.vehicle.tracking.locationPoints) {
            setLocationData((user.singleTripData.vehicle.tracking.locationPoints).reverse());
            let location = [];
            user.singleTripData.vehicle.tracking.locationPoints.map((data) => (
                location.push([data.latitude, data.longitude])
            ));
            if (location.length > 0) {
                setPolyLine(location);
            }
        }
        else {
            setPolyLine();
        }
    }, [user.singleTripData]);

    const handleRefreshClick = () => {

        dispatchGetSimTrackingLocation(tripId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Map Component Dweb", "Get Sim Tracking Location Successfull");
                    dispatchTripDetailsAction(journeyId,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                setRefreshClicked(true);
                            }
                        },
                        () => {

                        }
                    );
                }
            },
            () => {
                logger.log("Map Component Dweb", "Get Sim Tracking Location Failed");
            }
        );

    }

    const handleCancel = () => {
        history.push({
            pathname: `/trips/view/${journeyId}`,
            state: {
                id: 7,
                tripData: user.singleTripData,
                tripView: true,
                pageTitle: 'Trip Details',
                pageSubTitle: user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleNumber ? user.singleTripData.vehicle.vehicleNumber : ''
            }
        });
    }

    const handleGoogleMapClick = () => {
        let mapData = locationData && locationData.length > 0 ? locationData[0] : "";
        window.open("https://maps.google.com?q=" + mapData.latitude + "," + mapData.longitude);
    }

    const handleShare = () => {
        let vehicleLocationUrl = user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.tracking && user.singleTripData.vehicle.tracking.vehicleLocationUrl ? user.singleTripData.vehicle.tracking.vehicleLocationUrl : "";
        let locationArray = vehicleLocationUrl.split('/');
        window.open("https://transportbook.in/vehicle-location.html?trip=?" + locationArray[locationArray.length - 1]);
    }

    let date = locationData && locationData[0] && locationData[0].device_time_epoch ? (locationData[0].device_time_epoch) : "";

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDiv} elevation={3}>

                    <div className={classes.divV2}>
                        <div className={classes.divV3}>
                            <div className={classes.divV4}>
                                <div className={classes.divV5}>
                                    <div className={classes.divV6}>
                                        {vehicleData && vehicleData.tracking && vehicleData.tracking.trackingStatus && vehicleData.tracking.trackingstatus == "completed" &&
                                            <>
                                                <div>
                                                    Destination Location
                                                </div>
                                                <div className={classes.divTracking}>
                                                    Tracking Completed
                                                </div>
                                            </>
                                        }
                                        {vehicleData && vehicleData.tracking && vehicleData.tracking.trackingStatus && vehicleData.tracking.trackingstatus != "completed" &&
                                            <>
                                                <div>
                                                    Last driver location
                                                </div>
                                                <div>
                                                    {getDatePickerDateInStringDDMMMYYYY(new Date((date * 1000)))}, &nbsp;{getTimeInHHMM(date)}
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className={classes.mtV1}>
                                        {locationData.length > 0 && locationData[0] ? (locationData[0]).address : ""}
                                    </div>
                                    <div className={classes.divV1}>
                                        <Button startIcon={<MapIcon className={classes.mapIcon} />} className={classes.googleButton} onClick={() => handleGoogleMapClick()}>
                                            Google Maps
                                        </Button>
                                        <div>
                                            <IconButton onClick={() => handleShare()}>
                                                <SimShareIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.mtV2}>
                                    <div className={classes.header}>TRIP HISTORY</div>
                                    <div className={classes.divTimeline}>
                                        <Timeline classes={{ root: classes.timeLineRoot }}>
                                            {locationData.length > 0 && (locationData).map((location, index) => {
                                                return (
                                                    <>
                                                        {/* {index == 0 &&
                                                            <TimelineItem classes={{ missingOppositeContent: classes.timeLineOppositeContent }}>
                                                                <TimelineSeparator className={classes.lineSeparator}>
                                                                    <TimelineDot classes={{ root: classes.dotRootV2 }}>
                                                                        <FiberManualRecordIcon className={classes.circleIconV1} />
                                                                    </TimelineDot>
                                                                    <TimelineConnector classes={{ root: classes.lineConnectorRootV1 }} />
                                                                </TimelineSeparator>
                                                                <TimelineContent classes={{ root: classes.timeLineContent }}>
                                                                    <div>
                                                                        <div className={classes.fw300}>
                                                                            {location.address}
                                                                        </div>
                                                                        <div className={classes.divAlign}>
                                                                            <div>{getMilliDatePickerDateInStringDDMMMYYYY(location.device_time_epoch)}</div>
                                                                            <div className={classes.bullet}>•</div>
                                                                            <div>{getTimeInHHMM(location.device_time_epoch)}</div>
                                                                        </div>
                                                                    </div>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        } */}
                                                        {/* {index == 0 &&
                                                            <TimelineItem classes={{ missingOppositeContent: classes.timeLineOppositeContent }}>
                                                                <TimelineSeparator className={classes.lineSeparator}>
                                                                    <TimelineDot classes={{ root: classes.dotRootV2 }}>
                                                                        <FiberManualRecordIcon className={classes.circleIconV1} />
                                                                    </TimelineDot>
                                                                    <TimelineConnector classes={{ root: classes.lineConnectorRootV1 }} />
                                                                </TimelineSeparator>
                                                                <TimelineContent classes={{ root: classes.timeLineContent }}>
                                                                    <div>
                                                                        <div className={classes.fw300}>
                                                                            {location.address}
                                                                        </div>
                                                                        <div className={classes.divAlign}>
                                                                            <div>23 April 2020</div>
                                                                            <div className={classes.bullet}>•</div>
                                                                            <div>06:10AM</div>
                                                                        </div>
                                                                    </div>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        }
                                                        {index == 0 &&
                                                            <TimelineItem classes={{ missingOppositeContent: classes.timeLineOppositeContent }}>
                                                                <TimelineSeparator className={classes.lineSeparator}>
                                                                    <TimelineDot classes={{ root: classes.dotRootV2 }}>
                                                                        <FiberManualRecordIcon className={classes.circleIconV1} />
                                                                    </TimelineDot>
                                                                    <TimelineConnector classes={{ root: classes.lineConnectorRootV1 }} />
                                                                </TimelineSeparator>
                                                                <TimelineContent classes={{ root: classes.timeLineContent }}>
                                                                    <div>
                                                                        <div className={classes.fw300}>
                                                                            {location.address}
                                                                        </div>
                                                                        <div className={classes.divAlign}>
                                                                            <div>23 April 2020</div>
                                                                            <div className={classes.bullet}>•</div>
                                                                            <div>06:10AM</div>
                                                                        </div>
                                                                    </div>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        } */}
                                                        {/* {index != 0 && index != locationData.length - 1 && */}
                                                        <TimelineItem key={index} classes={{ missingOppositeContent: classes.timeLineOppositeContent }}>
                                                            <TimelineSeparator>
                                                                <TimelineDot classes={{ root: ((locationData.length) - (index)) > 9 ? classes.dotRootTwoDigit : classes.dotRoot }}>
                                                                    <span className={classes.timeDot}>{(locationData.length) - (index)}</span>
                                                                </TimelineDot>
                                                                {index != locationData.length - 1 &&
                                                                    <TimelineConnector classes={{ root: classes.lineConnectorRoot }} />
                                                                }
                                                            </TimelineSeparator>
                                                            <TimelineContent classes={{ root: classes.timeLineContentV1 }}>
                                                                <div>
                                                                    <div className={classes.fw300}>
                                                                        {location.address}
                                                                    </div>
                                                                    <div className={classes.divAlign}>
                                                                        {index != 0 ?
                                                                            <>
                                                                                <div>{getMilliDatePickerDateInStringDDMMMYYYY(location.device_time_epoch)}</div>
                                                                                <div className={classes.bullet}>•</div>
                                                                                <div>{getTimeInHHMM(location.device_time_epoch)}</div>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <div>{moment(moment(Number(location.device_time_epoch*1000)).format('YYYYMMDDhmmssa'), "YYYYMMDDhmmssa").fromNow()}</div>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </TimelineContent>
                                                        </TimelineItem>
                                                        {/* } */}
                                                        {/* {index == locationData.length - 1 &&
                                                            <TimelineItem classes={{ missingOppositeContent: classes.timeLineOppositeContent }}>
                                                                <TimelineSeparator>
                                                                    <div>
                                                                        <TimelineDot classes={{ root: classes.dotRootV1 }}>
                                                                            <FiberManualRecordIcon className={classes.circleIcon} />
                                                                        </TimelineDot>
                                                                    </div>
                                                                </TimelineSeparator>
                                                                <TimelineContent classes={{ root: classes.timeLineContentV1 }}>
                                                                    <div>
                                                                        <div className={classes.fw300}>
                                                                            {location.address}
                                                                        </div>
                                                                        <div className={classes.divAlign}>
                                                                            <div>{getMilliDatePickerDateInStringDDMMMYYYY(location.device_time_epoch)}</div>
                                                                            <div className={classes.bullet}>•</div>
                                                                            <div>{getTimeInHHMM(location.device_time_epoch)}</div>
                                                                        </div>
                                                                    </div>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        } */}
                                                    </>
                                                )
                                            })}
                                        </Timeline>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.divV7}>
                                {polyLine && polyLine.length > 0 && polyLine[polyLine.length - 1] &&
                                    <MapContainer fullscreenControl={true}
                                        fullscreenControl={{
                                            position: 'topright',
                                            title: {
                                                'false': 'View Fullscreen',
                                                'true': 'Exit Fullscreen'
                                            },
                                        }}
                                        zoomControl={false} center={polyLine && polyLine.length > 0 && polyLine[polyLine.length - 1] ? polyLine[polyLine.length - 1] : center} zoom={16} scrollWheelZoom={false} style={{ height: '100%' }} >
                                        <TileLayer
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />

                                        {polyLine && polyLine.length > 0 && polyLine.map((location, index) => (
                                            // <>
                                            //     {index == 0 &&
                                            //         <Marker position={location} icon={customMarkerIconStart}>
                                            //         </Marker>
                                            //     }
                                            //     {(index != 0 && index != (polyLine.length - 1)) &&
                                            <Marker key={index} position={location} icon={customMarkerIcon(index + 1)}>
                                            </Marker>
                                            //     }
                                            //     {index == polyLine.length - 1 &&
                                            //         <Marker position={location} icon={customMarkerIconCurrent}>
                                            //         </Marker>
                                            //     }
                                            // </>
                                        ))
                                        }
                                        {/* {polyLine && polyLine.length > 0 &&
                                            <Polyline pathOptions={polyOption} positions={polyLine} />
                                        } */}

                                        <ZoomControl position="bottomright" className={classes.zoomControlV1} />

                                        {/* <FullscreenControl position="topright" /> */}
                                    </MapContainer>
                                }
                            </div>
                        </div>

                        {vehicleData && vehicleData.tracking && vehicleData.tracking.trackingStatus && vehicleData.tracking.trackingstatus != "completed" &&
                            <div className={classes.divText}>
                                <div className={classes.divV10}>
                                    <div className={classes.divV9}>
                                        {!refreshClicked &&
                                            'Auto Refresh at 6 AM and 6 PM. This is not counted for the Refresh Limit.'
                                        }
                                        {refreshClicked &&
                                            <span>
                                                Refresh Available in&nbsp;&nbsp;
                                        <Timer
                                                    initialTime={simTrackingConfig && simTrackingConfig.minimum_refresh_frequency_minutes ? simTrackingConfig.minimum_refresh_frequency_minutes * 60000 : 0}
                                                    // initialTime={120000}
                                                    direction="backward"
                                                    checkpoints={[
                                                        {
                                                            time: 0,
                                                            callback: () => setRefreshClicked(false),
                                                        }
                                                    ]}
                                                >
                                                    {({ getTime }) => (
                                                        <React.Fragment>

                                                            {(getTime() < 60000) ?
                                                                <>
                                                                    <Timer.Seconds />&nbsp;secs
                                                                </>
                                                                :
                                                                <>
                                                                    <Timer.Minutes />&nbsp;
                                                                    {(getTime() < 120000) ?
                                                                        'min' : 'mins'
                                                                    }
                                                                </>
                                                            }
                                                        </React.Fragment>
                                                    )}
                                                </Timer>
                                            </span>
                                        }
                                    </div>
                                    {/* <Button className={classes.cancelButton} onClick={() => handleCancel()}>
                                    Cancel
                                </Button> */}
                                    <Button className={refreshClicked ? classes.refreshButtonDisabled : classes.refreshButton} onClick={() => handleRefreshClick()} disabled={refreshClicked}>
                                        Refresh
                                        <span>({(simTrackingConfig && simTrackingConfig.trip_manual_refresh_limit ? simTrackingConfig.trip_manual_refresh_limit : "") - (user && user.singleTripData && user.singleTripData.vehicle.tracking && user.singleTripData.vehicle.tracking.numberOfLocationHits ? user.singleTripData.vehicle.tracking.numberOfLocationHits : "")}&nbsp;&nbsp;Available)</span>
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>

                </Paper>
            </Wrapper>
        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle, user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchTripDetailsAction: (journeyId, onSuccess, onError) => {
        dispatch(getJourneyDetails(journeyId, onSuccess, onError))
    },
    dispatchGetSimTrackingLocation: (journeyId, onSuccess, onFailure) => {
        dispatch(getLocationForSimTracking(journeyId, onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);
